import { SvgIconProps } from '@euler/app/components/icons/types';
import { useSvgProps } from '@euler/app/components/icons/util';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';
import { useTheme } from 'styled-components';

export namespace dropdown {
  export const CaretIcon: FC<SvgIconProps> = memo(props => {
    const { fill = '#9498A2', ...svgProps } = useSvgProps(props, 21, 21);
    return (
      <Svg viewBox="0 0 24 24" fill="none" {...svgProps}>
        <Path
          d="M5 15L12 8L19 15"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    );
  });

  export const Unchecked: FC<SvgIconProps> = memo(props => {
    const {
      fill = '#FFF',
      stroke = '#96A1AB',
      ...svgProps
    } = useSvgProps(props, 18, 18);
    return (
      <Svg viewBox="0 0 20 21" fill="none" {...svgProps}>
        <Path
          d="M0.267 2.726a1.96 1.96 0 011.96-1.96h15.547a1.96 1.96 0 011.96 1.96v15.548a1.96 1.96 0 01-1.96 1.96H2.226a1.96 1.96 0 01-1.96-1.96V2.726z"
          fill={fill}
        />
        <Path
          d="M0.267 2.726a1.96 1.96 0 011.96-1.96h15.547a1.96 1.96 0 011.96 1.96v15.548a1.96 1.96 0 01-1.96 1.96H2.226a1.96 1.96 0 01-1.96-1.96V2.726z"
          stroke={stroke}
          strokeWidth={0.533333}
        />
      </Svg>
    );
  });

  export const Checked: FC<SvgIconProps> = memo(props => {
    const theme = useTheme();
    const { fill = theme.form.input.borderColorFocused, ...svgProps } =
      useSvgProps(props, 18, 18);
    return (
      <Svg viewBox="0 0 20 21" fill="none" {...svgProps}>
        <Path
          d="M18.333 0.5H1.667A1.667 1.667 0 000 2.167v16.666A1.666 1.666 0 001.667 20.5h16.666A1.666 1.666 0 0020 18.833V2.167A1.667 1.667 0 0018.333 0.5zm-3.577 8.09l-5.833 5.833a.833.833 0 01-1.18 0l-2.5-2.5a.834.834 0 011.18-1.18l1.91 1.912 5.244-5.245a.833.833 0 111.18 1.18z"
          fill={fill}
        />
      </Svg>
    );
  });

  export const ClearIcon: FC<SvgIconProps> = memo(props => {
    const { fill = '#B5BDC4', ...svgProps } = useSvgProps(props, 18, 18);
    return (
      <Svg
        viewBox="0 0 24 24"
        fill="none"
        stroke={fill}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...svgProps}
      >
        <Path d="M18 6L6 18M6 6l12 12" />
      </Svg>
    );
  });
}
